export default {
    workload: {
        add_title: 'Add Workload',
        edit_title: 'Edit Workload',
        finish_title: 'Finish Workload',
    },

    app_search: {
        search_placeholder: 'Search Tickets or Tasks',
        search_placeholder_task: 'Search Tasks',
        search_placeholder_ticket: 'Search Tickets',
        search_info: 'Enter the number or title of a ticket or task',
        search_info_task: 'Enter the number or title of a task',
        search_info_ticket: 'Enter the number or title of a ticket',
    },
}
